export default __webpack_public_path__ + "static/media/qa.fba1f892.svg";